import Button from '@components/formControls/Button'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const EmptyProfilesWrapper = styled('div')`
  width: 100%;
  height: 100%;

  flex: 1 1 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const EmptyProfilesInner = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 450px;
`

export const EmptyShortlistPicture = styled('img')`
  width: 264px;
  height: 264px;
  margin-top: 16px;
  margin-bottom: 16px;
`

export const EmptyShortlistButton = styled(Button)`
  margin-bottom: 30px;

  padding: 12px 27px;
  height: 50px;
  border-radius: 58px;

  font-weight: 700;
  font-size: 20px;
  background-color: #3eabe3;
  color: ${colors.white};
`
